import { post,postAuth } from './client';
import { apiVariables } from './apiVariables';
import type {
  NewUserRegistration,
  CreateUserResponse,
  EmailAvailabilityResponse,
  LicenseValidationResponse,
  ProfilePictureUploadResponse,
  ConfirmEmailResponse,
} from '../../types/registration';



import type {
SetPasswordResponse,
} from '../../types/admin';

export const registrationService = {
  createUser: async (userData: NewUserRegistration): Promise<CreateUserResponse> => {
    const payload = {
      email: userData.email,
      password: userData.password,
      firstName: userData.firstName,
      lastName: userData.lastName,
      dateOfBirth: userData.dateOfBirth,
      phoneNumber: userData.phoneNumber,
      
      healthcareSpecialty: userData.healthcareSpecialty,
      licenseNumber: userData.licenseNumber,
      yearsOfExperience: userData.yearsOfExperience,
      currentWorkplace: userData.currentWorkplace,
      
      address: userData.address,
      city: userData.city,
      state: userData.state,
      zipCode: userData.zipCode,
      country: userData.country,
      
      bio: userData.bio,
      ExploreTechnologies: userData.ExploreTechnologies,
      profilePicture: userData.profilePicture,
      
      preferences: userData.preferences,
    };

    const response = await post<CreateUserResponse, typeof payload>(
      apiVariables.AUTH_REGISTER,
      payload
    );

    return response;
  },

  checkEmailAvailability: async (email: string): Promise<EmailAvailabilityResponse> => {
    const response = await post<EmailAvailabilityResponse, { email: string }>(
      apiVariables.AUTH_CHECK_EMAIL,
      { email }
    );
    return response;
  },

  uploadProfilePicture: async (file: File): Promise<ProfilePictureUploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await post<ProfilePictureUploadResponse, FormData>(
      apiVariables.USER_UPLOAD_PHOTO,
      formData
    );

    return response;
  },

  validateLicense: async (licenseNumber: string, specialty: string): Promise<LicenseValidationResponse> => {
    const response = await post<LicenseValidationResponse, { licenseNumber: string; specialty: string }>(
      apiVariables.AUTH_VALIDATE_LICENSE,
      { licenseNumber, specialty }
    );
    return response;
  },

  setPassword: async (token: string, password: string,confirmPassword: string): Promise<SetPasswordResponse>=>{
    const response = await post<SetPasswordResponse, { token: string;password: string,confirmPassword: string }>(
      apiVariables.REGISTRATION_SET_PASSWORD,
      { token, password,confirmPassword}
    );
    return response;
  },
setForgotPassword: async (
  token: string,
  password: string,
  confirmPassword: string
): Promise<{
  success: boolean;
  message: string;
  errors?: string[];
}> => {
  const response = await post<
    {
      success: boolean;
      message: string;
      errors?: string[];
    },
    {
      token: string;
      password: string;
      confirmPassword: string;
    }
  >(
    apiVariables.AUTH_Forgot_SET_PASSWORD,
    { token, password, confirmPassword }
  );

  return response;
},

resetPassword: async (
  oldPassword: string,
  newPassword: string,
  confirmPassword: string
): Promise<SetPasswordResponse> => {
  const response = await postAuth<SetPasswordResponse>(
    apiVariables.AUTH_RESET_PASSWORD,
    { oldPassword, newPassword, confirmPassword }
  );

  return response;
},

  confirmEmail: async (emailId: string, emailVerificationOtp: string): Promise<ConfirmEmailResponse>=>{
    const response = await post<ConfirmEmailResponse, { emailId: string;emailVerificationOtp: string }>(
      apiVariables.REGISTRATION_CONFIRM_EMAIL,
      { emailId, emailVerificationOtp}
    );
    return response;
  },
  
verifyForgotPasswordOtp: async (
  email: string,
  otp: string
): Promise<{
  success: boolean;
  message: string;
  data?: { passwordToken?: string };
  errors?: string[];
}> => {
  const response = await post<
    {
      success: boolean;
      message: string;
      data?: { passwordToken?: string };
      errors?: string[];
    },
    { email: string; otp: string }
  >(
    apiVariables.AUTH_Forgot_VERIFY_EMAIL,
    { email, otp }
  );

  return response;
},
 
  validateEmailDomain: async (email: string): Promise<{ success: boolean; message: string; errors?: string[] }> => {
    const response = await post<{ success: boolean; message: string; errors?: string[] }, { email: string }>(
      apiVariables.REGISTRATION_VALIDATE_EMAIL,
      { email }
    );
    return response;
  },

  resendOTP: async (email: string): Promise<{ success: boolean; message: string; errors?: string[] }> => {
    const response = await post<{ success: boolean; message: string; errors?: string[] }, { email: string }>(
      apiVariables.REGISTRATION_RESEND_OPT,
      { email }
    );
    return response;
  },
   forgotPassword: async (
    email: string
  ): Promise<{ success: boolean; message: string; errors?: string[] }> => {
    const response = await post<
      { success: boolean; message: string; errors?: string[] },
      { email: string }
    >(
      apiVariables.AUTH_FORGOT_PASSWORD,
      { email }
    );

    return response;
  },
  

  generateToken: async (email: string): Promise<{ success: boolean; message: string; verificationLink?: string }> => {
    const response = await post<{ success: boolean; message: string; data?: any }, { email: string }>(
      apiVariables.REGISTRATION_GENERATE_TOKEN,
      { email }
    );
    return response;
  },
};
